import React, { useState } from "react";
import axios from 'axios';
import {axiosEH} from '../common/functions'

export default function Pressoptions() {
  // 1. 1st-level vars
  const [statusMsg, setStatusMsg] = useState('');
  const user = JSON.parse(sessionStorage.getItem('user'));

  // ---- f()
  function getPressoptions() {
    // 1. chk

    // 2. get it
    const url = process.env.REACT_APP_BASEURL + '/userclasses/pressoptions';
    axios.get(url, { headers: { 'x-access-token': user['accessToken'] } })
      .then(res => {
        if ( !Array.isArray(res.data) ) {   // {}
          setStatusMsg(res.data.info);      // can not bee seen bcz child
        } else {  // [] ok
          setStatusMsg('');
          sessionStorage.setItem('pressoptions', JSON.stringify(res.data));
        }
      })
      .catch(err => { 
        setStatusMsg(axiosEH(err)); 
      })
  }

  React.useEffect(() => {
    const po = sessionStorage.getItem('pressoptions');
    if ( po == null || po == '' || po == '[]' ) {
      getPressoptions();
      //console.log('po 2: ', po)
    }
  }, []);   // []: render once only

  return (
    <label className="label has-text-success">{statusMsg}</label>
  );
}